import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import CloudCircleIcon from '@material-ui/icons/CloudCircle'
import WhatshotIcon from '@material-ui/icons/Whatshot'
import OpacityIcon from '@material-ui/icons/Opacity'
import AppShell from './components/layout/AppShell'
import PageCard from './components/ui/PageCard'
import Airbox from './airboxDashboard/Airbox'

class AirboxDashboard extends React.Component {
  state = { group: {} }

  async getGroupData() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getGroupData?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) this.setState({ group: data.data })
      else this.props.history.push('/groups')
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  componentDidMount() {
    this.getGroupData()
  }

  buildSecondaryNav() {
    const { match, location } = this.props
    const items = [
      { key: 'pm25', label: 'PM2.5', path: 'pm25', icon: <CloudCircleIcon /> },
      { key: 'temperature', label: '溫度', path: 'temperature', icon: <WhatshotIcon /> },
      { key: 'humidity', label: '濕度', path: 'humidity', icon: <OpacityIcon /> },
    ]
    return items.map((item) => ({
      ...item,
      to: `${match.url}/${item.path}`,
      active: location.pathname.includes(`/${item.path}`),
    }))
  }

  render() {
    const { match } = this.props
    const uniqid = match.params.uniqid
    return (
      <AppShell
        uniqid={uniqid}
        title={`環境 (I) · ${this.state.group.name || ''}`}
        subtitle={this.state.group.description}
        secondaryNav={this.buildSecondaryNav()}
      >
        <PageCard>
          <Route
            path={`${match.url}/pm25`}
            render={() => (
              <Airbox
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="pm25"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/temperature`}
            render={() => (
              <Airbox
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="temperature"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/humidity`}
            render={() => (
              <Airbox
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="humidity"
                uniqid={uniqid}
              />
            )}
          />
        </PageCard>
      </AppShell>
    )
  }
}

AirboxDashboard.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default AirboxDashboard
